import { render } from "./SupplierRequirements.vue?vue&type=template&id=0777aca6&scoped=true"
import script from "./SupplierRequirements.vue?vue&type=script&lang=js"
export * from "./SupplierRequirements.vue?vue&type=script&lang=js"

import "./SupplierRequirements.vue?vue&type=style&index=0&id=0777aca6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0777aca6"]])

export default __exports__